import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { canManageDevices } from '../lib/devices'

interface RequireOwnerOrManagerProps {
  children: ReactNode
  redirectTo?: string
}

/**
 * Route guard for a page the API keeps to the company's owner and managers by
 * role rather than by a permission code (Devices). Goes by the active persona,
 * so previewing as a Worker hides it too. Cosmetic — the API answers a worker 403.
 */
export default function RequireOwnerOrManager({ children, redirectTo = '/dashboard' }: RequireOwnerOrManagerProps) {
  const { activePersona, loading } = useAuth()
  if (loading) return null
  if (!canManageDevices(activePersona)) return <Navigate to={redirectTo} replace />
  return <>{children}</>
}
